import * as React from "react";
import { ToastContainer } from "react-toastify";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiUser } from "react-icons/fi";

import { Navigator } from "./Navigator";
import styles from "./styles.module.scss";
import logo from "../../assets/logo.png";

type CustomNavigationProps = {
  name?: string;
  user?: any;
  page?: string;
};

const CustomNavigation = ({ name, user, page }: CustomNavigationProps) => {
  const [toggle, setToggle] = React.useState(false);

  const displayName =
    user?.FirstName ||
    user?.fullname ||
    user?.name ||
    user?.PhoneNumber ||
    "Customer";

  const role =
    user?.UserRole ||
    user?.Role ||
    user?.role ||
    user?.userRole ||
    page ||
    "Admin";

  React.useEffect(() => {
    if (!toggle) return;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, [toggle]);

  return (
    <>
      <ToastContainer />

      <button
        type="button"
        className={styles.mobileToggle}
        onClick={() => setToggle((prev) => !prev)}
        aria-label={toggle ? "Close navigation menu" : "Open navigation menu"}
      >
        {toggle ? <FaTimes /> : <FaBars />}
      </button>

      {toggle && (
        <button
          type="button"
          className={styles.backdrop}
          onClick={() => setToggle(false)}
          aria-label="Close navigation"
        />
      )}

      <aside
        className={`${styles.navigation} ${
          toggle ? styles.mobileNavigation : ""
        }`}
      >
        <div className={styles.brandArea}>
          <div className={styles.logoBox}>
            <img src={logo} alt="NMFB Logo" />
          </div>

          <div>
            <strong>NMFB</strong>
            <span>Loan Portal</span>
          </div>
        </div>

        <div className={styles.userCard}>
          <div className={styles.userAvatar}>
            <FiUser />
          </div>

          <div className={styles.userInfo}>
            <strong>{displayName}</strong>
            <span>{role}</span>
          </div>
        </div>

        <Navigator
          name={name}
          page={page}
          user={user}
          onNavigate={() => setToggle(false)}
        />
      </aside>
    </>
  );
};

export default CustomNavigation;
